import angular from 'angular'

export const NominaTimbresTimbreXMLSchema = {}

export class NominaTimbresTimbreXMLService {

  constructor($http) {
    this.$http = $http
  }

  post (id_nomina, id_proyecto, id_colaborador, indice, version) {
    return this.$http.post(`api/nominas/nomina/timbres/timbre/xml`, {}, {
      params: {
        id_nomina,
        id_proyecto,
        id_colaborador,
        indice,
        version,
      },
      schema: NominaTimbresTimbreXMLSchema,
      clearCache: 'nominas',
    })
  }
}

angular.module('nominas.nomina')
  .service('NominaTimbresTimbreXML', NominaTimbresTimbreXMLService)



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Timbres/Timbre/XML.js